module.exports = __webpack_public_path__ + "img/btn_menu.4a1ce10a.png";